@if (!loading) {
  <div
    class="text-lg md:text-xl font-bold mb-5 text-mat-ef-revolution-primary-500"
    >
    <T
    str="Basic details"
    key="customerPortal.customer-portal.vehicle.basic.details"
    tags="customer-portal, 3.1"
  ></T>
</div>
}
@if (loading) {
  <div class="heading-skeleton px-5">
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
    ></ngx-skeleton-loader>
    <br />
  </div>
}
<mat-divider class="relative w-full"></mat-divider>
<div class="flex items-center h-16 mr-0">
  <div class="flex gap-5 items-center w-full">
    @if (!loading) {
      <div class="panel-icon">
        <mat-icon
          class="text-mat-ef-revolution-primary-500 mt-2.5 min-w-[20px] min-h-[20px]"
          svgIcon="vin"
        ></mat-icon>
      </div>
    }
    @if (loading) {
      <div class="panel-icon">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }

    <div class="w-full mr-5">
      @if (!loading) {
        <div
          class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500 font-semibold"
          >
          <T
          str="VIN (chassis number)"
          key="customerPortal.customer-portal.vehicle.details.vin"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    }
    @if (loading) {
      <div>
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }

    @if (!loading) {
      <div
        data-cy="vehicle-basic-details-vin"
        class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500"
        >
        {{ vehicle?.vin }}
      </div>
    }
    @if (loading) {
      <div class="skeleton-margin">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
  </div>
</div>
</div>
<mat-divider class="relative w-full"></mat-divider>
<div class="flex items-center h-16 mr-0">
  <div class="flex gap-5 items-center w-full">
    @if (!loading) {
      <mat-icon
        class="text-mat-ef-revolution-primary-500 mt-2.5 min-w-[20px] min-h-[20px]"
        svgIcon="carVin"
      ></mat-icon>
    }
    @if (loading) {
      <div class="panel-icon">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
    <div class="w-full mr-5">
      @if (!loading) {
        <div
          class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500 font-semibold"
          >
          <T
          str="Licence plate"
          key="customerPortal.customer-portal.vehicle.details.registration-plate"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    }
    @if (loading) {
      <div>
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }

    @if (!loading && showMask) {
      <div
        class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500"
        >
        {{ vehicle?.licensePlate | mask: licensePlateMask }}
      </div>
    }
    @if (!loading && !showMask) {
      <div
        class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500"
        >
        {{ vehicle?.licensePlate }}
      </div>
    }

    @if (loading) {
      <div class="skeleton-margin">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
  </div>
  @if (!loading) {
    <span
      data-cy="edit-license-plate-button"
      class="border-mat-ef-revolution-secondary-500 flex items-center cursor-pointer text-xs text-mat-ef-revolution-secondary-500 border-2 font-bold rounded h-6 leading-3 px-2 mr-2.5"
      (click)="
        editLicensePlate(vehicle);
        sendContentModulesMiniCTAData('shared.edit', 'license plate')
      "
      >
      <mat-icon
        color="secondary"
        class="text-mat-ef-revolution-secondary-500 min-w-[16px] min-h-[16px] max-w-[16px]"
        svgIcon="create"
      ></mat-icon>
      <ng-container *ngTemplateOutlet="edit"></ng-container>
    </span>
  }
</div>
</div>
<mat-divider class="relative w-full"></mat-divider>
<div class="flex items-center h-16 mr-0">
  <div class="flex gap-5 items-center w-full">
    @if (!loading) {
      <mat-icon
        class="text-mat-ef-revolution-primary-500 mt-2.5 min-w-[20px] min-h-[20px]"
        svgIcon="calendarDetails"
      ></mat-icon>
    }
    @if (loading) {
      <div class="panel-icon">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
    <div class="w-full mr-5">
      @if (!loading) {
        <div
          class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500 font-semibold"
          >
          <T
          str="Initial placing on the market"
          key="customerPortal.customer-portal.vehicle.details.first-registration"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    }
    @if (loading) {
      <div>
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
    @if (!loading) {
      <div
        class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500"
        >
        {{ (vehicle?.firstRegistration | date: dateFormat) || '-' }}
      </div>
    }
    @if (loading) {
      <div class="skeleton-margin">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
  </div>
  @if (
    vehicle?.createdByDataSource === 'customer_portal' &&
    !loading &&
    !vehicle?.business
    ) {
    <span
      data-cy="edit-first-registration-button"
      class="border-mat-ef-revolution-secondary-500 flex items-center cursor-pointer text-xs text-mat-ef-revolution-secondary-500 border-2 font-bold rounded h-6 leading-3 px-2 mr-2.5"
      (click)="
        editFirstRegistration(vehicle);
        sendContentModulesMiniCTAData('shared.edit', 'first registration')
      "
      >
      <mat-icon
        color="secondary"
        class="text-mat-ef-revolution-secondary-500 min-w-[16px] min-h-[16px] max-w-[16px]"
        svgIcon="create"
      ></mat-icon>
      <ng-container *ngTemplateOutlet="edit"></ng-container>
    </span>
  }
</div>
</div>
<mat-divider class="relative w-full"></mat-divider>
<div class="flex items-center h-16 mr-0">
  <div class="flex gap-5 items-center w-full">
    @if (!loading) {
      <mat-icon
        class="text-mat-ef-revolution-primary-500 mt-2.5 min-w-[20px] min-h-[20px]"
        svgIcon="Kilometerstand"
      ></mat-icon>
    }
    @if (loading) {
      <div class="panel-icon">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
    <div class="w-full mr-5">
      @if (!loading) {
        <div
          class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500 font-semibold"
          >
          <T
          str="Last service mileage"
          key="customerPortal.customer-portal.vehicle.details.mileage"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    }
    @if (loading) {
      <div>
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
    @if (!loading) {
      <div
        class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500"
        >
        {{ serviceKm || '-' }} km
      </div>
    }
    @if (loading) {
      <div class="skeleton-margin">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
  </div>
  @if (!loading && !vehicle?.business) {
    <span
      data-cy="edit-mileage-button"
      mat-button
      mat-stroked-button
      class="border-mat-ef-revolution-secondary-500 flex items-center cursor-pointer text-xs text-mat-ef-revolution-secondary-500 border-2 font-bold rounded h-6 leading-3 px-2 mr-2.5"
      color="secondary"
      (click)="
        editMileage(vehicle);
        sendContentModulesMiniCTAData('shared.edit', 'mileage')
      "
      >
      <mat-icon
        class="secondary"
        class="text-mat-ef-revolution-secondary-500 min-w-[16px] min-h-[16px] max-w-[16px]"
        svgIcon="create"
      ></mat-icon>
      <ng-container *ngTemplateOutlet="edit"></ng-container>
    </span>
  }
</div>
</div>
<mat-divider class="relative w-full"></mat-divider>

@if (vehicle?.createdByDataSource === 'customer_portal') {
  <div>
    <div class="flex items-center h-16 mr-0" data-cy="crud-leasing-expiry">
      <div class="flex gap-5 items-center w-full">
        @if (!loading) {
          <mat-icon
            class="text-mat-ef-revolution-primary-500 mt-2.5 min-w-[20px] min-h-[20px]"
            svgIcon="calendarDetails"
          ></mat-icon>
        }
        @if (loading) {
          <div class="panel-icon">
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }
        <div class="w-full mr-5">
          @if (!loading) {
            <div
              class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500 font-semibold"
              >
              <T
              str="Leasing expires"
              key="customerPortal.customer-portal.leasingExpiryDate"
              tags="customer-portal, 3.1"
            ></T>
          </div>
        }
        @if (loading) {
          <div>
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }
        @if (!loading) {
          <div
            class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500"
            >
            {{ (vehicle?.leasingExpiryDate | date: 'MM/yyyy') || '-' }}
          </div>
        }
        @if (loading) {
          <div class="skeleton-margin">
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }
      </div>
      @if (vehicle?.leasingExpiryDate && !loading) {
        <div class="displayFlex">
          <customer-portal-app-cpt-menu
            data-cy="edit-leasing-expiry-menu"
            [menuType]="'editDeleteMenu'"
          (actionClicked)="
            leasingExpiryNextServiceActionClicked($event, vehicle)
          "
            >
          </customer-portal-app-cpt-menu>
        </div>
      }
      @if (!vehicle?.leasingExpiryDate && !loading) {
        <span
          data-cy="edit-leasing-expiry-button"
          class="border-mat-ef-revolution-secondary-500 flex items-center cursor-pointer text-xs text-mat-ef-revolution-secondary-500 border-2 font-bold rounded h-6 leading-3 px-2 mr-2.5"
        (click)="
          editLeasingExpiryNextService(vehicle, 'leasingExpiryDate');
          sendContentModulesMiniCTAData('shared.edit', 'leasing expiry')
        "
          >
          <mat-icon
            color="secondary"
            class="text-mat-ef-revolution-secondary-500 min-w-[16px] min-h-[16px] max-w-[16px]"
            svgIcon="create"
          ></mat-icon>
          <ng-container *ngTemplateOutlet="edit"></ng-container>
        </span>
      }
    </div>
  </div>
  <mat-divider class="relative w-full"></mat-divider>
  <div class="flex items-center h-16 mr-0" data-cy="crud-next-service">
    <div class="flex gap-5 items-center w-full">
      @if (!loading) {
        <mat-icon
          class="text-mat-ef-revolution-primary-500 mt-2.5 min-w-[20px] min-h-[20px]"
          svgIcon="calendarDetails"
        ></mat-icon>
      }
      @if (loading) {
        <div class="panel-icon">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
      <div class="w-full mr-5">
        @if (!loading) {
          <div
            class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500 font-semibold"
            >
            <T
            str="Next appointment"
            key="customerPortal.customer-portal.nextServiceDate"
            tags="customer-portal, 3.1"
          ></T>
        </div>
      }
      @if (loading) {
        <div>
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
      @if (!loading) {
        <div
          class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500"
          >
          {{ (vehicle?.nextServiceDate | date: 'MM/yyyy') || '-' }}
        </div>
      }
      @if (loading) {
        <div class="skeleton-margin">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
    </div>
    @if (vehicle?.nextServiceDate && !loading) {
      <div class="displayFlex">
        <customer-portal-app-cpt-menu
          data-cy="edit-next-service-menu"
          [menuType]="'editDeleteMenu'"
          (actionClicked)="nextServiceDateActionClicked($event, vehicle)"
          >
        </customer-portal-app-cpt-menu>
      </div>
    }
    @if (!vehicle?.nextServiceDate && !loading) {
      <span
        data-cy="edit-next-service-button"
        class="border-mat-ef-revolution-secondary-500 flex items-center cursor-pointer text-xs text-mat-ef-revolution-secondary-500 border-2 font-bold rounded h-6 leading-3 px-2 mr-2.5"
        (click)="
          editLeasingExpiryNextService(vehicle, 'nextServiceDate');
          sendContentModulesMiniCTAData('shared.edit', 'next service')
        "
        >
        <mat-icon
          color="secondary"
          class="text-mat-ef-revolution-secondary-500 min-w-[16px] min-h-[16px] max-w-[16px]"
          svgIcon="create"
        ></mat-icon>
        <ng-container *ngTemplateOutlet="edit"></ng-container>
      </span>
    }
  </div>
</div>
<mat-divider class="relative w-full"></mat-divider>
</div>
}

<div class="flex items-center h-16 mr-0">
  <div class="flex gap-5 items-center w-full">
    @if (!loading) {
      <mat-icon
        class="text-mat-ef-revolution-primary-500 mt-2.5 min-w-[20px] min-h-[20px]"
        svgIcon="offer"
      ></mat-icon>
    }
    @if (loading) {
      <div class="panel-icon">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
    <div class="w-full mr-5">
      @if (!loading) {
        <div
          class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500 font-semibold"
          >
          <T
          str="Bought from"
          key="customerPortal.customer-portal.vehicle.details.purchased-at"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    }
    @if (loading) {
      <div>
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
    @if (!loading && vehicle) {
      <div
        class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500"
        >
        {{
        vehicle?.dealers?.purchasedDealer?.name
        ? vehicle.dealers.purchasedDealer.name +
        (', ' + vehicle.dealers.purchasedDealer.subname) || ''
        : ' - '
        }}
      </div>
    }
    @if (loading) {
      <div class="skeleton-margin">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
  </div>
</div>
</div>
<mat-divider class="relative w-full"></mat-divider>

@if (enableFrequentDriver) {
  <div class="flex items-center h-16 mr-0">
    <div class="flex gap-5 items-center w-full" data-cy="crud-frequent-driver">
      @if (!loading) {
        <mat-icon
          class="text-mat-ef-revolution-primary-500 mt-2.5 min-w-[20px] min-h-[20px]"
          svgIcon="driverIcon"
        ></mat-icon>
      }
      @if (loading) {
        <div class="panel-icon">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
      <div class="w-full mr-5">
        @if (!loading) {
          <div
            class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500 font-semibold"
            >
            <T
            str="Most frequent driver"
            key="customerPortal.customer-portal.vehicle.details.most-frequent-driver"
            tags="customer-portal, 3.1"
          ></T>
        </div>
      }
      @if (loading) {
        <div>
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
      @if (mostFrequentDriver && !loading) {
        <div
          class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500"
          >
          @if (
            mostFrequentDriver?.salutation?.toLowerCase() !== 'unspecified'
            ) {
            {{
            'salutation-' + mostFrequentDriver?.salutation?.toLowerCase()
            | sharedTranslate
            }}
          }
          {{
          mostFrequentDriver
          ? mostFrequentDriver?.firstName + ' ' + mostFrequentDriver?.lastName
          : ' - '
          }}
        </div>
      }
      @if (!mostFrequentDriver && !loading) {
        <div
          class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500"
          >
          -
        </div>
      }
      @if (loading) {
        <div class="skeleton-margin">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
    </div>
    @if (mostFrequentDriver && !loading) {
      <div class="cptMenuContainer p-0">
        <customer-portal-app-cpt-menu
          data-cy="edit-frequent-driver-menu"
          [menuType]="'editDeleteMenu'"
          (actionClicked)="frequentDriverActionClicked($event)"
          >
        </customer-portal-app-cpt-menu>
      </div>
    }
    @if (!mostFrequentDriver && !loading) {
      <span
        data-cy="add-frequent-driver-button"
        class="border-mat-ef-revolution-secondary-500 flex items-center cursor-pointer text-xs text-mat-ef-revolution-secondary-500 border-2 font-bold rounded h-6 leading-3 px-2 mr-2.5"
      (click)="
        openFrequentDriverPopUp();
        sendContentModulesMiniCTAData('shared.edit', 'frequent driver')
      "
        >
        <mat-icon
          color="secondary"
          class="text-mat-ef-revolution-secondary-500 min-w-[16px] min-h-[16px] max-w-[16px]"
          svgIcon="create"
        ></mat-icon>
        <ng-container *ngTemplateOutlet="edit"></ng-container>
      </span>
    }
  </div>
</div>
}
<mat-divider class="relative w-full"></mat-divider>
<div class="flex items-center h-16 mr-0" data-cy="crud-nickname">
  <div class="flex gap-5 items-center w-full">
    @if (!loading) {
      <mat-icon
        class="text-mat-ef-revolution-primary-500 mt-2.5 min-w-[20px] min-h-[20px]"
        svgIcon="directions_car"
      ></mat-icon>
    }
    @if (loading) {
      <div class="panel-icon">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
    <div class="w-full mr-5">
      @if (!loading) {
        <div
          class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500 font-semibold"
          >
          <T
          str="Does your car have a name?"
          key="customerPortal.customer-portal.vehicle.details.nickname"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    }
    @if (loading) {
      <div>
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
    @if (!loading) {
      <div
        class="text-xs sm:text-sm text-efSans text-mat-ef-revolution-primary-500"
        >
        {{ vehicle?.nickname ? vehicle?.nickname : ' - ' }}
      </div>
    }
    @if (loading) {
      <div class="skeleton-margin">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
  </div>
  @if (vehicle?.nickname && !loading) {
    <div class="cptMenuContainer p-0">
      <customer-portal-app-cpt-menu
        data-cy="edit-nickname-menu"
        [menuType]="'editDeleteMenu'"
        (actionClicked)="nicknameActionClicked($event, vehicle)"
        >
      </customer-portal-app-cpt-menu>
    </div>
  }
  @if (!vehicle?.nickname && !loading) {
    <span
      data-cy="edit-nickname-button"
      class="border-mat-ef-revolution-secondary-500 flex items-center cursor-pointer text-xs text-mat-ef-revolution-secondary-500 border-2 font-bold rounded h-6 leading-3 px-2 mr-2.5"
      (click)="
        editNickname(vehicle);
        sendContentModulesMiniCTAData('shared.edit', 'nickname')
      "
      >
      <mat-icon
        color="secondary"
        class="text-mat-ef-revolution-secondary-500 min-w-[16px] min-h-[16px] max-w-[16px]"
        svgIcon="create"
      ></mat-icon>
      <ng-container *ngTemplateOutlet="edit"></ng-container>
    </span>
  }
</div>
</div>
<mat-divider class="relative w-full"></mat-divider>

<ng-template #edit>
  {{ 'edit' | sharedTranslate }}
</ng-template>
